
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate/faqs",
      function () {
        return require("private-next-pages/corporate/faqs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate/faqs"])
      });
    }
  